/**
 * @generated SignedSource<<706975c3257454fba51b06d7f6c97509>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NavSectionKind = "custom" | "products" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DeleteNavSectionButtonFragment$data = {
  readonly id: string;
  readonly kind: NavSectionKind;
  readonly ordering: number;
  readonly organizationId: string;
  readonly title: string;
  readonly " $fragmentType": "DeleteNavSectionButtonFragment";
};
export type DeleteNavSectionButtonFragment$key = {
  readonly " $data"?: DeleteNavSectionButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteNavSectionButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteNavSectionButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ordering",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationId",
      "storageKey": null
    }
  ],
  "type": "NavSection",
  "abstractKey": null
};

(node as any).hash = "cb5504553798e0edc74121c1e0cb158c";

export default node;
